import { render, staticRenderFns } from "./checkMiddle.vue?vue&type=template&id=55cad972&"
import script from "./checkMiddle.vue?vue&type=script&lang=js&"
export * from "./checkMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports